"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelContainer = exports.HelpTextContainer = exports.DigitInput = exports.StyledLabel = exports.Row = void 0;
const native_1 = __importStar(require("styled-components/native"));
const Typography_styles_1 = require("../../atoms/Typography/Typography.styles");
exports.Row = native_1.default.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
`;
exports.StyledLabel = native_1.default(Typography_styles_1.Label) `
  margin-bottom: ${({ theme }) => `${theme.bpCore.gridSize}px`};
`;
exports.DigitInput = native_1.default.TextInput `
  margin-right: 8px;
  width: 48px;
  height: 48px;
  text-align: center;
  font-family: ${({ theme }) => theme.bpCore.textInput.fontFamily};
  color: ${({ theme }) => theme.bpCore.textInput.default.color};
  background-color: ${({ theme }) => theme.bpCore.textInput.default.backgroundColor};
  border: 1px solid
    ${({ theme }) => theme.bpCore.textInput.default.borderColor};
  ${({ error, theme }) => error &&
    native_1.css `
      color: ${theme.bpCore.textInput.error.color};
      background-color: ${theme.bpCore.textInput.error.backgroundColor};
      border-color: ${theme.bpCore.textInput.error.borderColor};
    `}
`;
exports.HelpTextContainer = native_1.default.View `
  flex-direction: row;
  margin-top: ${({ theme }) => `${theme.bpCore.gridSize}px`};
`;
exports.LabelContainer = native_1.default.View `
  flex-direction: column;
  align-items: baseline;
`;
